function Footer() {
  return (
    <footer>
      <div className="wrap footer-content">
        <div><b>이동은</b> · 보험설계사<br />당신의 보험을 끝까지 책임지는 한 사람.</div>
        <div className="legal">
          © 2026 이동은. All rights reserved.<br />
          <small>본 페이지는 보험 상담 안내용이며 특정 상품의 청약을 권유하지 않습니다.<br />보장 내용·보험금 지급 기준은 약관 및 상품설명서를 따릅니다.<br />본 페이지에 표기된 후기는 예시이며 실제와 다를 수 있습니다.</small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
